import AbstractUIScreen, {ORIENTATION, STAGE_MODES} from "../screen/AbstractUIScreen";
import {inject} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import IApp from "../../engine/IApp";
import IScreenData from "../screen/IScreenData";
import {repaint} from "../AbstractUI";
import IUIMessages from "../messages/IUIMessages";

import * as oce from "orientationchangeend";
import events from "../../events/EventsObservable";
import {LOADER_EVENTS} from "../../loader/BaseLoader";
import MobileDOM from "./MobileDOM";
import {isIphoneSafari} from "../../device/device";

const OCE = oce({
    noEndTimeout: 1000,
    noChangeCountToEnd: 100
});

export default class MobileUIScreen extends AbstractUIScreen {

    protected dom: MobileDOM;

    private _lastFullscreen: boolean;
    private _portInitHeight: number;

    // private _orientChangeTimeout: number;
    private _recalcSwiperEnabled = true;
    private loadHided = false;

    uiType: string = "default";

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.EngineApp) app: IApp,
        @inject(SERVICE_IDENTIFIER.UIMessages) uiMessages: IUIMessages,
        @inject(SERVICE_IDENTIFIER.DOM) dom: MobileDOM
    ) {
        super(config, app, uiMessages);
        this.dom = dom;

        window.addEventListener("orientationchange", () => {
            // clearTimeout(this._orientChangeTimeout);
            this._recalcSwiperEnabled = true;
        });

        OCE.on('orientationchangeend', () => {
            setTimeout(() => this.resize(), 700);

        });

        events.subscribe(LOADER_EVENTS.LOADER_HIDED, this.loaderHided.bind(this));
    }

    private loaderHided() {
        this.loadHided = true;
        this.resize();
    }

    protected resizeControls(data: IScreenData) {
        $(".mx-controls-wrapper").css({
            width: data.containerWidthOrig,
            height: data.containerHeightOrig,
            transform: `scale(${data.containerScale})`
        });

        if(STAGE_MODES.PORT === data.mode) {
            this.resizeControlsPort(data);
        } else {
            this.resizeControlsLand(data);
        }

        setTimeout(() => {
            repaint($(".mx-controls-wrapper")); //ios fix
        });
    }

    private resizeControlsPort(data: IScreenData) {

        let top = data.canvasHeightScaled * (1 / data.containerScale);
        let menuHeight = $("#mxBar").height();
        let height = data.containerHeightOrig - top - menuHeight;

        $(".mx-buttons-container, #mxBurgerMenuUL").css({"top": top, "width": data.containerWidthOrig, "height": height});
        $(".bet-menu, .autostart-menu").css({"width": data.containerWidthOrig, "height": data.containerHeightOrig - menuHeight });

    }

    private resizeControlsLand(data: IScreenData) {
        $(".mx-buttons-container, .bet-menu, .autostart-menu").css({"top": 0, "width": data.containerWidthOrig + "px", "height": data.containerHeightOrig + "px"});
        $("#mxBurgerMenuUL").css({"top": 0, "width": "100%", "height": "100%"});
    }

    public resize() {
        let screenData = this.getScreenData();
        super.resize(screenData);

        this._recalcSwiperEnabled = true;

        this._resizeIOSSwiper(screenData);

        setTimeout(() => {
            this._resizeIOSSwiper(screenData);
        }, 400);
    }

    _resizeIOSSwiper(data: IScreenData) {
        window.scrollTo(0, 0);

        if(!this.loadHided || !this._recalcSwiperEnabled) {
            return;
        }


        if(!this.dom.isSwiperEnabled()) {
            return;
        }

        let isFullscreen;

        // iphone fullscreen check
        if (isIphoneSafari()) {
            if(data.orientation === ORIENTATION.LAND) {
                window.scrollTo(0, 0);
                isFullscreen = (screen.width == window.innerHeight);
            } else {
                if(this._portInitHeight == null) {
                    this._portInitHeight = window.innerHeight;
                }
                isFullscreen = !(this._portInitHeight >= window.innerHeight) ||
                window.innerHeight >= Math.floor(window.screen.height*0.93233082707);
            }
        } else { // android fullscreen check
            isFullscreen = !!document.fullscreenElement;
        }

        this._lastFullscreen = isFullscreen;
        this.dom.fullscreenSwiper.enable(!isFullscreen);
    }
}
